export const historyRoutes = {
  GET_PURCHASE_HISTORY: (partnerId: string) => `/PurchaseHistory/${partnerId}/p?startDate=2021-01-01T00:00:00`, // Bitrix API
  GET_ACTIVE_COURTS: "/ActiveCourts/", // Bitrix API
  GET_PAYMENT_DATES: "/orders/payment-dates", // основной API (наш бэкенд)
};
